import React, { Component } from 'react';

import TextField from '../form/TextField';
import AddressField from '../form/AddressField';
import SelectField from '../form/SelectField';
import PhoneField from '../form/PhoneField';
import EmailField from '../form/EmailField';

import JusticeField from './JusticeField';
import SIRENField from './SIRENField';
import formStyles from '../form/Form.css';

import naf from '../../shared/naf.json';
import legalForm from '../../shared/legalForm.json';

const nafOptions = naf.map(n => ({
  label: `${n[1]} - ${n[0]}`,
  value: n[1],
}));

class LegalPersonField extends Component {
  render() {
    const { model, isAuthor } = this.props;

    return (
      <div>
        <TextField
          model={`${model}.legalName`}
          label="Dénomination sociale"
          required
        />

        <SIRENField
          model={`${model}.siren`}
          label="SIREN"
          required
        />

        <SelectField
          model={`${model}.nafCode`}
          label="Code NAF"
          inputProps={{
            options: nafOptions,
          }}
          required
        />

        <SelectField
          model={`${model}.legalForm`}
          label="Forme juridique"
          inputProps={{
            options: legalForm,
          }}
          required
        />

        <TextField
          model={`${model}.rcs`}
          label="RCS (ville)"
          required
        />

        <TextField
          model={`${model}.lastName`}
          label="Nom du signataire"
          required
        />

        <TextField
          model={`${model}.firstName`}
          label="Prénom du signataire"
          required
        />

        <AddressField
          model={`${model}.address`}
          label="Adresse"
          required
        />

        <EmailField
          model={`${model}.email`}
          label="Email"
          required
        />

        <PhoneField
          model={`${model}.phoneNumber`}
          label="Téléphone"
          required
        />

        <JusticeField
          isAuthor={isAuthor}
          model={model}
        />

        <div className={formStyles.title}>
          Documents justificatifs
        </div>

        <TextField
          inputProps={{
            type: 'file',
            accept: '.pdf',
          }}
          model={`${model}.kbisFile`}
          label="Extrait KBIS (PDF)"
          required
        />
      </div>
    );
  }
}

export default LegalPersonField;



/** WEBPACK FOOTER **
 ** ./client/act/LegalPersonField.js
 **/